import { Typography } from "antd";
import React, { memo } from "react";
import { useTranslation } from "react-i18next";

import { SideBarLogo } from "@sol/uikit/core/icons/SideBarLogo";

import { simplonWebsiteUrl } from "../../../constants/externalLinks";

const LoginLayoutHero = () => {
    const [t] = useTranslation();

    return (
        <div className="flex flex-[2] items-center justify-center" role="banner">
            <div className="relative m-ant-xl flex max-w-[520px] flex-col gap-ant">
                <SideBarLogo className="w-[200%] self-center" />
                {/* <SimplonLogo src="/static/sol-logo.png" alt="Simplonline" className="self-end" /> */}
                <Typography.Title level={1}>
                    {t("layout.login.heroIntroduction")}
                    <br />
                    <a
                        className="mt-ant block text-right underline"
                        target="_blank"
                        rel="noopener noreferrer"
                        href={simplonWebsiteUrl}
                    >
                        <u>{t("page.login.hero.poweredBySimplon")}</u>
                    </a>
                </Typography.Title>
            </div>
        </div>
    );
};

export default memo(LoginLayoutHero);
